/* eslint-disable no-restricted-imports -- Only place needed to import flat-ui components */
import {
  Alert as AlertFlatUI,
  AlertProps,
  Banner as BannerFlatUI,
  BannerProps,
  CardSelector as CardSelectorFlatUI,
  CardSelectorProps,
  ChipStatusProps,
  CircularProgress as CircularProgressFlatUI,
  CircularProgressProps,
  Dialog as DialogFlatUI,
  DialogProps,
  Dropdown as DropdownFlatUI,
  DropdownProps,
  FaroBreadcrumbs,
  FaroBreadcrumbsProps,
  FaroButton,
  FaroButtonProps,
  FaroCheckbox,
  FaroCheckboxProps,
  FaroCheckboxGroupProps,
  FaroCheckboxGroup,
  FaroChip,
  FaroChipProps,
  FaroChipStatus,
  FaroIconButton,
  FaroIconButtonProps,
  FaroMenu,
  FaroMenuItem,
  FaroMenuItemProps,
  FaroMenuProps,
  FaroMenuSection,
  FaroMenuSectionProps,
  FaroMenuSeparator,
  FaroMenuSeparatorProps,
  FaroPopover,
  FaroPopoverProps,
  FaroRadio,
  FaroRadioProps,
  FaroRadioGroup,
  FaroRadioGroupProps,
  FaroSvgIcon,
  FaroSvgIconProps,
  FaroSwitch,
  FaroSwitchProps,
  FaroText,
  FaroTextProps,
  FaroToggleGroup,
  FaroToggleGroupProps,
  FaroTooltip,
  FaroTooltipProps,
  FeedbackDialog as FeedbackDialogFlatUI,
  FeedbackDialogProps,
  HelpCenterMenu as HelpCenterMenuFlatUI,
  HelpCenterMenuProps,
  LoadingScreen as LoadingScreenFlatUI,
  LoadingScreenProps,
  PasswordValidationChecker as PasswordValidationCheckerFlatUI,
  PasswordValidationCheckerProps,
  RemainingTimeLabel as RemainingTimeLabelFlatUI,
  RemainingTimeLabelProps,
  SingleSelectItem as SingleSelectItemFlatUI,
  SingleSelectItemProps,
  TextField as TextFieldFlatUI,
  TextFieldProps,
  TranslateVar as TranslateVarFlatUI,
  TranslateVarProps,
  UserAvatar as UserAvatarFlatUI,
  UserAvatarProps,
  UserMenu as UserMenuFlatUI,
  UserMenuProps,
  FilterMenu as FilterMenuFlatUI,
  FilterMenuProps,
  Accordion as AccordionFlatUI,
  AccordionProps,
  UserCardItem as UserCardItemFlatUI,
  UserCardItemProps,
  Autocomplete as AutocompleteFlatUI,
  AutocompleteProps,
  ColorPalette as ColorPaletteFlatUI,
  ColorPaletteProps,
} from "@faro-lotv/flat-ui";
/* eslint-enable no-restricted-imports */
import { devFeaturesStateSelector } from "@store/dev-features/dev-features-selector";
import { useAppSelector } from "@store/store-helper";
import { PropsWithChildren } from "react";

/** Wrapper component for the flat-ui Alert component */
export function Alert(props: PropsWithChildren<AlertProps>): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <AlertFlatUI {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui Banner component */
export function Banner(props: PropsWithChildren<BannerProps>): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <BannerFlatUI {...props} />;
}

/** Wrapper component for the flat-ui FaroBreadcrumbs component */
export function Breadcrumbs(props: FaroBreadcrumbsProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <FaroBreadcrumbs {...props} />;
}

/** Wrapper component for the flat-ui Button component */
export function Button(props: PropsWithChildren<FaroButtonProps>): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroButton {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui CardSelector component */
export function CardSelector(props: CardSelectorProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <CardSelectorFlatUI {...props} />;
}

/** Wrapper component for the flat-ui FaroCheckbox component */
export function Checkbox(props: FaroCheckboxProps): JSX.Element {
  return <FaroCheckbox {...props} />;
}

/** Wrapper component for the flat-ui FaroCheckboxGroup component */
export function CheckboxGroup(props: FaroCheckboxGroupProps): JSX.Element {
  return <FaroCheckboxGroup {...props} />;
}

/** Wrapper component for the flat-ui FaroChip component */
export function Chip(props: FaroChipProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <FaroChip {...props} />;
}

/** Wrapper component for the flat-ui ChipStatus component */
export function ChipStatus(props: ChipStatusProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroChipStatus {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui CircularProgress component */
export function CircularProgress(props: CircularProgressProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <CircularProgressFlatUI {...props} />;
}

/** Wrapper component for the flat-ui Dialog component */
export function Dialog(props: PropsWithChildren<DialogProps>): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <DialogFlatUI {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui Dropdown component */
export function Dropdown(props: DropdownProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <DropdownFlatUI {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui FeedbackDialog component */
export function FeedbackDialog(props: FeedbackDialogProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <FeedbackDialogFlatUI {...props} />;
}

/** Wrapper component for the flat-ui Alert component */
export function FilterMenu(props: FilterMenuProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FilterMenuFlatUI {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui HelpCenterMenu component */
export function HelpCenterMenu(props: HelpCenterMenuProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <HelpCenterMenuFlatUI {...props} />;
}

/** Wrapper component for the flat-ui FaroIconButton component */
export function IconButton(props: FaroIconButtonProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroIconButton {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui LoadingScreen component */
export function LoadingScreen(props?: LoadingScreenProps): JSX.Element {
  return <LoadingScreenFlatUI {...props} />;
}

/** Wrapper component for the flat-ui FaroMenu component */
export function Menu(props: FaroMenuProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroMenu {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui FaroMenuItem component */
export function MenuItem(props: FaroMenuItemProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroMenuItem {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui FaroMenuSection component */
export function MenuSection(props: FaroMenuSectionProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroMenuSection {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui FaroMenuSeparator component */
export function MenuSeparator(props: FaroMenuSeparatorProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroMenuSeparator {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui PasswordValidationChecker component */
export function PasswordValidationChecker(
  props: PasswordValidationCheckerProps
): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <PasswordValidationCheckerFlatUI {...props} />;
}

/** Wrapper component for the flat-ui FaroPopover component */
export function Popover(props: FaroPopoverProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroPopover {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui Radio component */
export function Radio(props: FaroRadioProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <FaroRadio {...props} />;
}

/** Wrapper component for the flat-ui RadioGroup component */
export function RadioGroup(
  props: PropsWithChildren<FaroRadioGroupProps>
): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <FaroRadioGroup {...props} />;
}

/** Wrapper component for the flat-ui RemainingTimeLabel component */
export function RemainingTimeLabel(
  props: RemainingTimeLabelProps
): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <RemainingTimeLabelFlatUI {...props} />;
}

/** Wrapper component for the flat-ui SingleSelectItem component */
export function SingleSelectItem(props: SingleSelectItemProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <SingleSelectItemFlatUI {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui FaroSvgIcon component */
export function SvgIcon(props: FaroSvgIconProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <FaroSvgIcon {...props} />;
}

/** Wrapper component for the flat-ui FaroSwitch component */
export function Switch(props: FaroSwitchProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroSwitch {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui Text component */
export function Text(props: PropsWithChildren<FaroTextProps>): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <FaroText {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui TextField component */
export function TextField(props: TextFieldProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <TextFieldFlatUI {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui FaroToggleGroup component */
export function ToggleGroup<T extends string>(
  props: FaroToggleGroupProps<T>
): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <FaroToggleGroup {...props} />;
}

/** Wrapper component for the flat-ui FaroTooltip component */
export function Tooltip(props: FaroTooltipProps): JSX.Element {
  // TODO: dark mode might never be needed since tooltips are always in dark mode
  return <FaroTooltip {...props} />;
}

/** Wrapper component for the flat-ui TranslateVar component */
export function TranslateVar(props: TranslateVarProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <TranslateVarFlatUI {...props} />;
}

/** Wrapper component for the flat-ui UserAvatar component */
export function UserAvatar(props: UserAvatarProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <UserAvatarFlatUI {...props} dark={isDarkModeEnabled} />;
}

/** Wrapper component for the flat-ui UserMenu component */
export function UserMenu(props: UserMenuProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <UserMenuFlatUI {...props} />;
}

/** Wrapper component for the flat-ui Accordion component */
export function Accordion(props: AccordionProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <AccordionFlatUI {...props} />;
}

/** Wrapper component for the flat-ui Accordion component */
export function UserCardItem(props: UserCardItemProps): JSX.Element {
  // TODO: dark mode is not yet supported for this component
  return <UserCardItemFlatUI {...props} />;
}

/** Wrapper component for the flat-ui Autocomplete component */
export function Autocomplete(props: AutocompleteProps): JSX.Element {
  return <AutocompleteFlatUI {...props} />;
}

/** Wrapper component for the flat-ui ColorPalette component */
export function ColorPalette(props: ColorPaletteProps): JSX.Element {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);
  return <ColorPaletteFlatUI {...props} dark={isDarkModeEnabled} />;
}
